import { render, staticRenderFns } from "./userNotifications.vue?vue&type=template&id=03c9145a&scoped=true"
import script from "./userNotifications.vue?vue&type=script&lang=js"
export * from "./userNotifications.vue?vue&type=script&lang=js"
import style0 from "./userNotifications.vue?vue&type=style&index=0&id=03c9145a&prod&scoped=true&lang=less"
import style1 from "./userNotifications.vue?vue&type=style&index=1&id=03c9145a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9145a",
  null
  
)

export default component.exports